/**
 * <announcement-dismiss>: lets shoppers close the announcement bar for the
 * rest of the browsing session. The button ships `hidden` so it never shows
 * without JavaScript; an inline guard in sections/announcement-bar.liquid
 * re-applies the state before paint on later pages (no flash, no layout shift).
 */
if (!customElements.get('announcement-dismiss')) {
  customElements.define(
    'announcement-dismiss',
    class AnnouncementDismiss extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        if (!this.button) return;
        this.button.hidden = false;
        this.button.addEventListener('click', () => this.dismiss());
      }

      dismiss() {
        try {
          sessionStorage.setItem(`announcement-dismissed:${this.dataset.key}`, '1');
        } catch (error) {
          // Storage can be unavailable (private mode); the bar still closes for this page.
        }
        const section = this.closest('.shopify-section');
        if (section) {
          section.hidden = true;
          section.classList.add('hidden');
        }
        document.querySelector('.header__heading-link')?.focus();
      }
    }
  );
}
